import { render } from "./FacilityDashboard.vue?vue&type=template&id=c6bfb7c2&scoped=true"
import script from "./FacilityDashboard.vue?vue&type=script&lang=js"
export * from "./FacilityDashboard.vue?vue&type=script&lang=js"

import "./FacilityDashboard.vue?vue&type=style&index=0&id=c6bfb7c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6bfb7c2"]])

export default __exports__